export default {
  totalSalesBySegment: 'Total {kpi} by Segment',
  dataView: 'Data View',
  close: 'Close',
  refresh: 'Refresh',
  saveAsImage: 'Save as Image'
}
